module.exports = "/_next/static/images/USSSGlance-2x-fad6fa483eeb91a0e8b8dc2143a49b89.jpg.webp";